import React, { Component } from 'react';
import RequestApi from '../../Miscelania/RequestApi';
import config from 'react-global-configuration';
import { Button, Modal, Grid, Row, Col, Navbar, NavItem, Nav, MenuItem, NavDropdown } from 'react-bootstrap';

// Importação do Router
import { Redirect, Link } from 'react-router-dom';
import Loading from '../../Miscelania/Loading';
import Alerta from '../../Miscelania/Alerta';
import Select from 'react-select';
const PropTypes = require('prop-types');

class ExamArchivedAcoes extends Component {
  desativar_loading () {
    this.setState({status_loading: 0});
  } 
  desativar_alerta () {
    this.setState({status_alerta: 0});
  } 

  // Handlers de form
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  constructor(props) {
    super(props);

    this.state = {
      status_loading: 0,
      redirect_url: false,
      mensagem_alerta: false,
      tipo_alerta: false,
      status_alerta: false,
      class_edit: '',
      class_status: '',
      alt_status: '',
      title_status: '',
      exam_date: '',
      hora_inicial: '',
      hora_final: '',
      modal: false,
      dados: [],
      lista_instrutores: [],
      lista_provas: [],
      questao: {},
      questoes: {},
      opcoes: [],
      questao_selecionada: 'undefined',
      message_contest: '',
    };
    //bind geral
    // handleChange e handleChangeSelect necessitam do bind nas tags
    this.desativar_alerta = this.desativar_alerta.bind(this);
    this.desativar_loading = this.desativar_loading.bind(this);
    this.showModal = this.showModal.bind(this);
    this.trocarActive = this.trocarActive.bind(this);
    this.atualizarQuestao = this.atualizarQuestao.bind(this);
    this.questaoSelecionada = this.questaoSelecionada.bind(this);
    this.verificarQuestaoSelecionada = this.verificarQuestaoSelecionada.bind(this);
    this.buscarQuestoes = this.buscarQuestoes.bind(this);
    this.downloadExam = this.downloadExam.bind(this);
    this.export = this.export.bind(this);
  }

  componentDidMount () {
    this.refs.request_api.verifyPermission();
  }

  trocarActive () {
    var datasave = {
      id: this.props.dadosProva.id,
      active: 1,
    };
    var confirmacao = window.confirm('Tem certeza que deseja ativar essa prova?');
    if(confirmacao) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/prova/change_active', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.props.refreshTable(responseJson);
          }
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }
  atualizarQuestao (value) {
    this.setState({questaoSelecionada: value});
    return true;
  }

  questaoSelecionada (questao_selecionada) {
    var atualizacao = this.atualizarQuestao(questao_selecionada);
    var self = this;
    Promise.resolve(atualizacao).then(function(value) {
      self.verificarQuestaoSelecionada();
    });
  }

  buscarQuestoes () {
    var url = config.get('api') + '/prova/usuario/buscar_questoes/' + this.props.dadosProva.id;
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).then((responseJson) => {
        if (responseJson.status === 'success') {
          self.setState({questoes: responseJson.data});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  downloadExam () {
    var url = config.get('api') + '/download/prova/finalizada/' + this.props.dadosProva.id;
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);       
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  export() {
    var self = this;
    var url = "/exportar/resultado/prova/" + this.props.dadosProva.id;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);       
        }
      });
    });
  }


  verificarQuestaoSelecionada () {
    if(this.state.questaoSelecionada === null || typeof this.state.questaoSelecionada === 'undefined') {
      this.context.router.history.push('/usuario/prova');
    } else {
      var questao = this.state.questoes[this.state.questaoSelecionada];
      var opcoes = questao.team_training_matter_staff_exam_question_option;
      this.setState({questao: questao});
      this.setState({opcoes: opcoes});
    }
  }
  
  showModal(event) {
    this.setState({ modal: true }, this.buscarQuestoes());
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  {(this.state.status_loading != 0) ? <Loading ativo={this.state.status_loading} desativar={this.desativar_loading} />: ""}
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <button onClick={this.trocarActive} className='btn btn-xs btn-danger' alt='Trocar para ativado' title="Trocar para ativado"><i className="fa fa-fw fa-power-off"></i></button>
  <button onClick={this.showModal} className='btn btn-info btn-xs'><i className="fa fa-fw fa-eye"></i></button>
  <button onClick={this.downloadExam} className='btn btn-success btn-xs'><i className="fa fa-fw fa-download"></i></button>
  <button onClick={this.export} className='btn btn-defaut btn-xs'><i className="fa fa-fw fa-file-pdf-o"></i></button>
  <Modal show={this.state.modal} aria-labelledby="contained-modal-title-sm" bsSize={'large'}>
    <Modal.Header className='modal-prova'>
      <div className="row">
        <div className="col-md-6">
            <h4 className="pull-left"><b>Revisão de prova do aluno: {this.props.dadosProva.staff}</b></h4>
        </div>
        <div className="col-md-6">
          <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
          <i className="fa fa-fw fa-close"></i></button>
        </div>
      </div>
    </Modal.Header>
    <Modal.Body className='modal-prova'>
      <div className="row dados-prova-modal">
        <div className="col-md-6">
            <p><b>Código: </b>{this.props.dadosProva.id}</p>
            <p><b>Treinamento: </b>{this.props.dadosProva.training}</p>
            <p><b>Matéria: </b>{this.props.dadosProva.matter}</p>
            <p><b>Status: </b><span className={(self.props.dadosProva.status == 'aprovada') ? 'label-success' : 'label-danger'}>{(self.props.dadosProva.status == 'aprovada') ? 'Aprovada' : 'Reprovada'}</span></p>
            <p><b>Início: </b>{this.props.dadosProva.date_exam_start_str} {this.props.dadosProva.hour_exam_started}</p>
            <p><b>Fim: </b>{this.props.dadosProva.date_exam_start_str} {this.props.dadosProva.hour_exam_finish}</p>
        </div>
        <div className="col-md-6">
            <p><b>Total de questões: </b>{this.props.dadosProva.qtd_questoes}</p>
            <p><b>Acertos: </b>{this.props.dadosProva.qtd_acertadas}</p>
            <p><b>Erros: </b>{this.props.dadosProva.qtd_erradas}</p>
            <p><b>Nota: </b>{this.props.dadosProva.result}</p>
            <p><b>Tempo total de prova:</b> {this.props.dadosProva.exam_time_str}</p>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <p>Basta selecionar a questão para verificar se a mesma encontra-se contestada.</p>
        </div>
      </div>
      <div className="row">
        {Object.keys(self.state.questoes).map(function(k) {
          return (
            <div className="col-md-1">
              <div onClick={() => self.questaoSelecionada(k)} className={(self.state.questoes[k].contested === 1) ? "modal-prova-quadrado-questoes-fundo quadrado-contestada" : (self.state.questoes[k].selected == self.state.questoes[k].option_correct_number) ? "modal-prova-quadrado-questoes-fundo quadrado-correta" : "modal-prova-quadrado-questoes-fundo quadrado-incorreta"}>
                <h5>{(self.state.questoes[k].selected) ? self.state.questoes[k].question_number + ' - ' + self.state.questoes[k].selected_str : self.state.questoes[k].question_number}</h5>
              </div>
            </div>
          );
        })}
      </div>
      <hr/>
      {(this.state.questaoSelecionada === null || typeof  this.state.questaoSelecionada === 'undefined') ?  '' :
        <div>
          <div className="row">
            <div className="col-md-6">
              <h4>Questão {self.state.questao.question_number}:</h4>
            </div>
            <div className="col-md-6 text-right">
              {(typeof self.state.questao.question === 'undefined') ?  '' : <h4>Cod. {self.state.questao.question.number} </h4> }
            </div>
          </div>
          <hr/>
          <div dangerouslySetInnerHTML={{__html: self.state.questao.question_content}}></div>
          <hr/>
          <table className="table tabela-questao-opcoes">
            <tbody>
              {Object.keys(self.state.opcoes).map(function(k) {
                return (
                  <tr>
                    <td className="checkbox-questao-opcoes"><div className={(self.state.opcoes[k].selected == 1) ? 'opcao-selecionada' : 'opcao'}>{(self.state.opcoes[k].selected == 1) ? 'X' : ''}</div></td>
                    <td><span>{self.state.opcoes[k].option_number}) </span>{self.state.opcoes[k].option_name}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <hr/>
            <h3 className="text-center">Opção correta: <span className="opcao-correta">{this.state.questao.option_correct_number}</span></h3>
              {(this.state.questao.contested === 1) ? <div><hr/><h4 className="bg-danger">Contestação</h4><p>{this.state.questao.message}</p></div> : ""}
          <br/>
          <hr/>
          {this.state.questao.justified == 1 ? 
              <span className={(self.state.questao.validate == 1) ? 'text-center label-success' : 'text-center label-danger'}>{(self.state.questao.validate == 1) ? 'CONTESTAÇÃO VALIDADA' : 'CONTESTAÇÃO INVALIDADA'}</span>
            : ""
          }
        </div>
      }
    </Modal.Body>
  </Modal>
</div>
    );
  }
}

ExamArchivedAcoes.contextTypes = {
  router: React.PropTypes.object.isRequired
}

export default ExamArchivedAcoes;



// WEBPACK FOOTER //
// ./src/Components/Exams/Elements/ExamArchivedAcoes.js